// extracted by mini-css-extract-plugin
module.exports = {"TherapyArticlesMobile":"TherapyArticlesMobile_TherapyArticlesMobile__2gCbi"};